import { useEffect } from "react";
import { AssignmentService } from "@/services/AssignmentService";
import { useActiveUser } from "@/store/selectors";
import { useActiveAssignment } from "@/store/selectors/assignmentSelectors";
import { useStore } from "@/store";

export const AssignmentLogic = () => {
  const activeUser = useActiveUser();
  const activeAssignment = useActiveAssignment();
  const assignmentId = activeAssignment?.id;
  const updateCurrentUserAssignmentResponses = useStore(
    (state) => state.assignmentResponses.updateCurrentUserAssignmentResponses,
  );

  useEffect(() => {
    if (assignmentId && activeUser?.id) {
      AssignmentService.subscribeToUserAssignmentResponses({
        assignmentId,
        userId: activeUser?.id,
        callback: (responses) => {
          updateCurrentUserAssignmentResponses(assignmentId, responses);
        },
      });
    }
  }, [assignmentId, activeUser?.id, updateCurrentUserAssignmentResponses]);

  return null;
};
